import { defineMessages } from "react-intl";

export default defineMessages({ 
    policyholderLoginHeaderText: {
        id: 'forgot-userid.component.forgot-userid-header.Policyholder login',
        defaultMessage: 'Policyholder login' 
    },
    accountRecoveryHeaderText: {
        id: 'forgot-userid.component.forgot-userid-header.Account recovery',
        defaultMessage: 'Account recovery' 
    },
    policySearchErrorMessage: {
        id: 'forgot-userid.component.forgot-userid-header.Policy Search Error Message',
        defaultMessage: 'The information you entered does not match our records. Please recheck your policy or billing statement and reenter.'
    },
    informationHeaderText: {
        id: 'forgot-userid.component.forgot-userid-header.Please enter your policy details below to locate your account. ',
        defaultMessage: 'Please enter your policy details below to locate your account. ' 
    },
    forgotUserIDFormContinueButtonText: {
        id:'forgot-userid.component.forgot-userid-form.Continue',
        defaultMessage: 'Continue'
    }
});